import { useState } from "react";
import { useSelector } from "react-redux";

export const usePaymentModes = (handleDynamicValues) => {
    const [paymentTypeSelected, setPaymentTypeSelected] = useState("");
    const { selectedCompany } = useSelector((state) => state.servicePayments);
    const { paymentModes, fetchingModes } = selectedCompany;
    const hasPaymentType = paymentModes.length > 0 || fetchingModes;

    const isCABpayment = paymentTypeSelected === "CAB";

    const handleModesChange = (modeId, values, resetForm) => {
        const selectedPaymentMode = paymentModes.find((mode) => mode.value === modeId);
        setPaymentTypeSelected(selectedPaymentMode.paymentType);
        const dynamicValues = handleDynamicValues(selectedPaymentMode.form);
        resetForm({ companyCode: values.companyCode, paymentType: values.paymentType, ...dynamicValues });
    };

    return { paymentModes, fetchingModes, hasPaymentType, handleModesChange, paymentTypeSelected, isCABpayment };
};

export default usePaymentModes;
